import { getLastArrayItem } from "@app/util/get-last-array-item";

export const checkSpecialSinglePage = (pageUrlName?: string, splittedUrl?: string[]): boolean => {
  if (!splittedUrl || !pageUrlName) return false;

  return splittedUrl.includes(pageUrlName) && getLastArrayItem(splittedUrl) !== pageUrlName;
};
